import React, { Component } from 'react'
//material-ui
import withStyles from "@material-ui/core/styles/withStyles";
//dashboard-pro
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
//components
import ReactTable from "react-table";
//css
import {dangerColor,infoColor} from "assets/jss/material-dashboard-pro-react.jsx";

const style = {
    // ...regularFormsStyle,
    tipsText:{color:dangerColor[1]},
    tipsTextBackground:{
        backgroundColor:infoColor[6],
        border:'1px solid',
        borderColor:infoColor[1],
        padding:'5px 15px',
        borderRadius:'10px'
    }
}

class Result extends Component {
    constructor(props){
        super(props);
        this.state = {
            tableData:[],
        };
    }

    render() {
        const tableColumns = [
            {Header:'合作意向方',accessor:'demanderName',sortable:false},
            {Header:'分供商类别',accessor:'categoryName',sortable:false},
            {Header:'入驻审核状态',accessor:'examineStatusDesc',sortable:false},
            {Header:'审核说明',accessor:'examineDescribe',sortable:false},
        ]
        const {classes} = this.props;
        return (
            <div style={{height:"calc(64vh)"}}>
                <GridContainer className={classes.tipsText}>
                    <GridItem xs={2} sm={2} md={2}></GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                        <div className={classes.tipsTextBackground}>
                            <div>注意事项：</div>
                            <div>1、在评审没有通过之前，您是不能参与任何项目的报名与投标；在评审通过之后，您才可以正常的参加项目的报名和投标。</div>
                            <div>2、如果“审批不通过”时，您只需要根据退回原因，直接点击“返回修改”按钮修改相关信息，之后重新提交申请即可。</div>
                        </div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}></GridItem>
                </GridContainer>
                <ReactTable data={this.props.formObj} columns={tableColumns} 
                    defaultPageSize={5}
                    pageSize={this.props.formObj.length > 0 ? this.props.formObj.length : 5}
                    className="-striped -highlight"/>
            </div>
        )
    }
}

export default withStyles(style)(Result);